import { reactive } from 'vue';

export const feedback = reactive({ message: '', visible: false });

export function errorMessage(error, fallback) {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return 'You appear to be offline. Check your connection and try again.';
  }
  if (error?.code === 'ECONNABORTED' || error?.name === 'AbortError') {
    return 'The request took too long. Please try again.';
  }
  if (error?.response?.status === 429) {
    return 'The service is busy. Please wait a moment and try again.';
  }
  return (
    fallback ||
    'We could not complete the request. Please try again. If you were saving changes, refresh and check whether they were saved before submitting again.'
  );
}

export function reportError(error) {
  // Do not display raw server responses, request headers, or credentials.
  feedback.message = errorMessage(error);
  feedback.visible = true;
}

// Only use for reads: retrying a write can create duplicate records.
const pendingLoads = new WeakMap();

export function loadData(vm, task, flag = 'isLoading') {
  if (pendingLoads.has(vm)) return pendingLoads.get(vm);
  vm[flag] = true;
  vm.loadError = '';
  const request = Promise.resolve()
    .then(task)
    .catch((error) => {
      vm.loadError = errorMessage(error, 'We could not load this data. Check your connection and try again.');
    })
    .finally(() => {
      vm[flag] = false;
      pendingLoads.delete(vm);
    });
  pendingLoads.set(vm, request);
  return request;
}
